import { apiRoutes } from '@/config/routes'
import type { BenchmarkDataPoint } from '@/queries/historicalBenchmarks.query'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { HOUR_IN_SECONDS, SECOND_IN_MILLISECONDS } from '@vaultsfyi/common/constants'

type AllNetworksBenchmarkData = Record<string, BenchmarkDataPoint[]>

interface AllNetworksBenchmarksResponse {
  data: AllNetworksBenchmarkData
  loadTime: number
  fromCache: boolean
  success: boolean
  error?: string
}

export function allNetworksBenchmarksQueryOptions(code: 'usd' | 'eth') {
  return queryOptions({
    queryKey: ['allNetworksBenchmarks', code] as const,
    async queryFn({ queryKey }) {
      const [, code] = queryKey
      const params = new URLSearchParams({ code })
      const response = await fetch(`${apiRoutes.apiHistoricalBenchmarks}?${params}`)
      if (!response.ok) {
        throw new Error('Failed to fetch historical benchmarks')
      }
      return response.json() as Promise<AllNetworksBenchmarksResponse>
    },
    retry: 3,
    staleTime: HOUR_IN_SECONDS * SECOND_IN_MILLISECONDS,
    select(data) {
      if (!data?.success) return null
      return data.data
    },
  })
}

export const useAllNetworksBenchmarksQuery = ({ code }: { code: 'usd' | 'eth' }) => {
  const { data, isFetching } = useQuery(allNetworksBenchmarksQueryOptions(code))
  return { data, isFetching }
}
